import CsList from './CsList';


export default {
    list :CsList,
    
};